// ═══════════════════════════════════════════════════════════════════════════
// WRITTN - Reflection Screen Component (Session End)
// ═══════════════════════════════════════════════════════════════════════════

import { PROMPTS } from '../config/prompts.js';
import { getSessionState, resetSession } from '../services/storage.js';

function getRandomItem(array) {
    return array[Math.floor(Math.random() * array.length)];
}

export function createReflectionCard(onContinue) {
    const state = getSessionState();
    const savedVerses = state.currentSessionFavorites || [];

    const prompt = getRandomItem(PROMPTS.sessionEndPrompts);
    const blessing = getRandomItem(PROMPTS.blessings);

    const card = document.createElement('div');
    card.className = 'reflection-card';
    card.id = 'reflection-card';

    card.innerHTML = `
    <div class="reflection-header">A moment to reflect</div>
    <p class="reflection-prompt">${prompt}</p>
    
    ${savedVerses.length > 0 ? `
      <div class="reflection-saved">
        <p class="reflection-saved-header">${PROMPTS.sessionSummaryHeader}</p>
        ${savedVerses.slice(0, 3).map(v => `
          <div class="reflection-saved-verse">
            ${v.text.substring(0, 150)}${v.text.length > 150 ? '...' : ''}
            <span class="reflection-saved-ref">${v.reference}</span>
          </div>
        `).join('')}
      </div>
    ` : ''}
    
    <p class="reflection-blessing">${blessing}</p>
    
    <button class="reflection-continue-btn">Continue reading</button>
  `;

    const btn = card.querySelector('.reflection-continue-btn');
    btn.addEventListener('click', () => {
        resetSession();
        if (onContinue) onContinue();
    });

    return card;
}

export default createReflectionCard;
